import React from 'react';
import { motion } from 'framer-motion';

const LeadingWithPurpose = () => {
    const textVariants = {
        hidden: { opacity: 0, y: 25 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.6, ease: "easeOut" }
        }
    };

    return (
        <section className="w-full bg-[#F1F1F1] py-16 lg:py-24 overflow-hidden select-none text-left">
            <div className="max-w-[1440px] w-full mx-auto px-6 sm:px-12 lg:px-[120px]">

                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center w-full">

                    <div className="lg:col-span-6 w-full flex items-center justify-center relative">
                        <div className="absolute w-[70%] aspect-square rounded-full bg-emerald-500/5 blur-[80px] pointer-events-none" />

                        <motion.div
                            animate={{
                                y: [0, -12, 0],
                                rotate: [0, 1, -1, 0]
                            }}
                            transition={{
                                duration: 6,
                                repeat: Infinity,
                                ease: "easeInOut"
                            }}
                            className="w-full max-w-[520px] aspect-[4/3] overflow-hidden shadow-[0_15px_40px_rgba(0,0,0,0.06)] bg-[#030f26]"
                        >
                            <img
                                src="/assets/sustainability/img1.png"
                                alt="3D Abstract glowing geometric grid loop artwork"
                                className="w-full h-full object-cover scale-102 transition-transform duration-500 hover:scale-105"
                            />
                        </motion.div>
                    </div>

                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.3 }}
                        transition={{ staggerChildren: 0.15 }}
                        className="lg:col-span-6 flex flex-col items-start w-full max-w-[560px]"
                    >
                        <motion.h2
                            variants={textVariants}
                            className="text-[#01386A] text-[20px] lg:text-[30px] font-[600] tracking-tight leading-tight mb-6 font-sora"
                        >
                            Leading with Purpose
                        </motion.h2>

                        <motion.div
                            variants={textVariants}
                            className="flex flex-col gap-5 text-[#49577A] text-[14px] sm:text-[16px] leading-relaxed font-[500] font-graphik"
                        >
                            <p>
                                We are committed to pursuing 'Purpose Beyond Profits' by embedding environmental, social, and governance (ESG) principles into our core strategy while balancing sustainability and overall profitability. By combining these efforts, we're helping ensure a healthier planet for all of us and providing greater value for our shareholders.
                            </p>
                            <p>
                                As an organization with a global footprint, global footprint, Mobikode is committed to promoting sustainability promoting sustainability in all that we do.
                            </p>
                        </motion.div>
                    </motion.div>

                </div>

            </div>
        </section>
    );
};

export default LeadingWithPurpose;